module.exports = [{
      plugin: require('../node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":840},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"2ParadiseDevlog","short_name":"2paradise","start_url":"/","background_color":"#3399ff","theme_color":"#3399ff","display":"minimal-ui","icon":"src/images/blog-logo.jpeg","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"6242c6f4a7a2fc3c16cbd047f76fbd4a"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
